import { useContext } from "react";
import { ForgotPasswordContext } from "./ForgotPasswordContextProvider";

const useForgotPasswordContext = () => useContext(ForgotPasswordContext);

export default useForgotPasswordContext;
